import template from './appHeader.html';
import controller from './appHeader.controller';

let appHeaderComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default appHeaderComponent;



// WEBPACK FOOTER //
// ./app/common/appHeader/appHeader.component.js